Vue.component('catalog-phone', {
    data() {
        return {}
    },
    methods: {
        toggle() {
            let wrapper = document.querySelector('.catalog__side-wrapper')
            wrapper.classList.toggle('catalog__side-wrapper_active')
        }
    }
})